import { useTranslation } from "react-i18next";
import BackButton from "./BackButton";

/** si este layout no cumple con lo que necesitas puedes crear otro */
export default function Layout({
  children,
  backLabel,
  title,
  titleClassName,
  description,
  hideBackButton = false,
  maxWidth = 530,
}: {
  children: React.ReactNode;
  title: string;
  titleClassName?: string;
  description?: React.ReactNode;
  backLabel?: string;
  hideBackButton?: boolean;
  maxWidth?: number;
}) {
  const { t } = useTranslation();
  
  return (
    <section
      className="container"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto 1fr",
        alignItems: "center",
        maxWidth: 1000
      }}
    >
      {!hideBackButton && <BackButton label={backLabel || t("back")} />}
      <div
        className="d-flex justify-content-center flex-column mt-3"
        style={{ justifySelf: "center", maxWidth: maxWidth, width: "100%"}}
      >
        <div className="">
          <h1 className={`size-24 font-weight-600 ${titleClassName}`}>{title}</h1>
          {description ? (
            <p className="size-16 font-weight-400 text-muted mb-4">
              {description}
            </p>
          ) : null}
        </div>
        {children}
      </div>
    </section>
  );
}


